module.exports = __webpack_public_path__ + "chatbotinfost/webchat_static/media/fa-duotone-900.d80e8433.ttf";